import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { marked } from 'marked';
import Nav from '../components/Nav/Nav';
import Footer from '../components/Footer/Footer';
import '../style/Article.css';

export default function Article() {
  const { slug } = useParams();
  const { getArticle, currentArticle } = useAuth();
  const navigate = useNavigate();


  useEffect(() => {
   getArticle(slug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  

  const { title, content, cover, category, publishedAt } = currentArticle;
  const imageUrl = cover?.url ?? null;

  return (
    <>
    <Nav home></Nav>
   {title && <>
    <article className="article-root">
      {/* ──────────── Conteneur TEXTE (colonne étroite) ──────────── */}
      <div className="article-text head">
        <p className="article-category">{category?.name}</p>
        <h1 className="article-title">{title}</h1>
        <p className="article-date">
          {new Date(publishedAt).toLocaleDateString('fr-FR', {
            day: 'numeric', month: 'long', year: 'numeric',
          })}
        </p>
      </div>

      {/* ──────────── Conteneur IMAGE (plus large) ──────────── */}
      
        <div className="article-img-wrapper">
          <div className="article-img" style={{backgroundImage: `url(${imageUrl})`}}></div>
        </div>
      

      {/* ──────────── Contenu markdown (même largeur que texte) ──────────── */}
      <section
        className="article-text article-content"
        dangerouslySetInnerHTML={{ __html: marked.parse(content ?? '') }}
      />
    </article>
    {/* ----- Métadonnées en bas ----- */}
<div className=" article-text">
  <div className='article-meta '>
  <p className="article-author">
    Publié par {currentArticle.author || 'Fastline'}
  </p>

  <p className="article-category-line">
    Catégorie&nbsp;: <span onClick={() => navigate(`/blog`)} className="article-category-value">{category?.name}</span>
  </p>
</div>
</div>

<Footer />
</>}
    </>
  );
}
